import { FileIcon } from 'lucide-react';
import {
  ARTIFACT_KIND_PALETTE,
  type ArtifactKindPaletteEntry,
} from '../../lib/artifact-kind-palette';

// A chip's `kind` can be a free-form string (e.g. history snapshots), so widen
// the palette key to surface the genuine "unknown kind" case the fallback handles.
const ICON_BY_KIND: Record<string, ArtifactKindPaletteEntry | undefined> = ARTIFACT_KIND_PALETTE;

interface Props {
  kind: string;
  className?: string;
}

/**
 * Renders the workspace-wide icon for an artifact kind (Library, filters,
 * intake, attachment chips), falling back to a generic file icon for unknown
 * kinds so a chip always shows something sensible.
 */
export function ArtifactKindIcon(props: Props) {
  const Icon = ICON_BY_KIND[props.kind]?.icon ?? FileIcon;
  return <Icon className={props.className ?? 'size-4 text-foreground'} />;
}
